<template>
  <footer class="has-padding-t-6 has-padding-b-6" v-bind:class="isClear ? '' : 'footer'">
    <div class="container has-padding-lr-6">
      <div class="columns">

        <div class="column"></div>

        <div class="column is-half has-text-centered" >
          <p class="is-relative" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
            Handcrafted with
            <span :ref="heart" class="heart-beat">
              <i class="fas fa-heart"></i>
            </span>
            &
            <span :ref="coffee" class="cup-shake" v-bind:class="isLanding ? 'has-text-athens-white' : 'has-text-manatee-grey'">
              <i class="fas fa-coffee"></i>
            </span>
            in New York City
          </p>
          <p class="is-size-7 is-relative" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
            {{copyright}} - {{firm}} {{resRights}}
          </p>
          <p class="level-item is-relative is-mobile has-margin-t-7" v-if="isVisible">
            <a class="is-size-5 has-margin-r-7" v-bind:href="followSocials.facebookUrl" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a class="is-size-5 has-margin-r-7" v-bind:href="followSocials.twitterUrl" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
              <i class="fab fa-twitter"></i>
            </a>
            <a class="is-size-5 has-margin-r-7" v-bind:href="followSocials.instagramUrl" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
              <i class="fab fa-instagram"></i>
            </a>
            <a class="is-size-5 has-margin-r-7" v-bind:href="followSocials.pinterestUrl" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
              <i class="fab fa-pinterest"></i>
            </a>
            <a class="is-size-5" v-bind:href="followSocials.linkedinUrl" v-bind:class="isLanding ? 'has-text-solitude-grey' : 'has-text-mischka-grey'">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </p>
        </div>

        <div class="column has-vertically-aligned-content">
          <div class="level-right" v-if="isVisible">
            <ul class="level-item is-size-7 is-relative">
              <li class="links">
                <a v-bind:href="blog.mediumUrl" v-bind:class="isLanding ? 'has-text-solitude-white' : 'has-text-mischka-grey'">{{blog.text}}</a>
              </li>
              <li class="links" v-for="(link, index) in links" :key="index">
                <router-link v-bind:to=link exact v-bind:class="isLanding ? 'has-text-solitude-white' : 'has-text-mischka-grey'">{{link}}</router-link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'NavFooter',
  data: function () {
    return {
      copyright: '\u00A9 2018',
      firm: 'giada, Inc.',
      resRights: 'All Rights Reserved',
      blog: {
        text: 'Blog',
        mediumUrl: 'https://medium.com/@giada_ai'
      },
      links: [
        'Terms',
        'Privacy',
        'Contact'
      ],
      followSocials: {
        facebookUrl: 'https://www.facebook.com/giadaai',
        twitterUrl: 'https://twitter.com/giada_ai',
        instagramUrl: 'https://www.instagram.com/giada.ai',
        pinterestUrl: 'https://www.pinterest.com/giada_ai',
        linkedinUrl: 'https://www.linkedin.com/company/giada-ai'
      },
      heart: 'heart',
      coffee: 'coffee'
    }
  },
  props: {
    isVisible: {
      default: true,
      type: Boolean
    },
    isLanding: {
      default: true,
      type: Boolean
    },
    isClear: {
      default: true,
      type: Boolean
    }
  },
  mounted () {
    let cuore = this.$refs.heart
    let caffe = this.$refs.coffee
    this.$nextTick(function () {
      window.addEventListener('orientationchange', function () {
        cuore.classList.remove('heart-beat')
        caffe.classList.remove('cup-shake')
        // void this.clientWidth
        void caffe.offsetWidth
        void cuore.offsetWidth
        cuore.classList.add('heart-beat')
        caffe.classList.add('cup-shake')
      })
    })
  }
}
</script>

<style scoped>

  .is-relative {
    position: relative;
    z-index: 2;
  }

  .footer {
    background-color: #F9FAFB;
    padding: 3rem 1rem 6rem;
  }

  .has-vertically-aligned-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

/* Links CSS */
   ul li.links a {
    padding-right: 0.25em;
    padding-left: 0.25em;
  }

  ul li.links:after {
    content: " | ";
    color: hsl(0, 0%, 71%);
  }

  ul li.links:last-child:after {
    content: none;
  }  /* remove the pipe from the last list item   .level-right */

/* Icon Animations CSS */
  .heart-beat > svg {
    -webkit-animation: heart-beat 5s ease infinite;
    animation: heart-beat 5s ease infinite;
    color: #bd081c;
  }

  @keyframes heart-beat {
    0% { -webkit-transform: scale(1); transform: scale(1); }
    5% { -webkit-transform: scale(1.25); transform: scale(1.25); }
    20% {-webkit-transform: scale(1); transform: scale(1); }
    30% {-webkit-transform: scale(1); transform: scale(1); }
    35% {-webkit-transform: scale(1.25); transform: scale(1.25); }
    50% {-webkit-transform: scale(1); transform: scale(1); }
    55% {-webkit-transform: scale(1.25); transform: scale(1.25); }
    70% {-webkit-transform: scale(1); transform: scale(1); }
  }

  @-webkit-keyframes heart-beat {
    0% { -webkit-transform: scale(1); transform: scale(1); }
    5% { -webkit-transform: scale(1.25); transform: scale(1.25); }
    20% {-webkit-transform: scale(1); transform: scale(1); }
    30% {-webkit-transform: scale(1); transform: scale(1); }
    35% {-webkit-transform: scale(1.25); transform: scale(1.25); }
    50% {-webkit-transform: scale(1); transform: scale(1); }
    55% {-webkit-transform: scale(1.25); transform: scale(1.25); }
    70% {-webkit-transform: scale(1); transform: scale(1); }
  }

  .cup-shake > svg {
    -webkit-animation: cup-shake 3s linear infinite;
    animation: cup-shake 3s linear infinite;
    /*color: #91949B;/*#533a29;*/ /*#1c0f0b #6F4E37;*/
  }

  @keyframes cup-shake {
    0% { -webkit-transform: scale(1); transform: scale(1); }
    10%, 20% { -webkit-transform: scale(.9) rotate(-8deg); transform: scale(.9) rotate(-8deg); }
    30%, 50%, 70% { -webkit-transform: scale(1.25) rotate(8deg); transform: scale(1.25) rotate(8deg); }
    40%, 60% { -webkit-transform: scale(1.25) rotate(-8deg); transform: scale(1.25) rotate(-8deg); }
    80%, 100% { -webkit-transform: scale(1) rotate(0); transform: scale(1) rotate(0); }
  }

  @-webkit-keyframes cup-shake {
    0% { -webkit-transform: scale(1); transform: scale(1); }
    10%, 20% { -webkit-transform: scale(.9) rotate(-8deg); transform: scale(.9) rotate(-8deg); }
    30%, 50%, 70% { -webkit-transform: scale(1.25) rotate(8deg); transform: scale(1.25) rotate(8deg); }
    40%, 60% { -webkit-transform: scale(1.25) rotate(-8deg); transform: scale(1.25) rotate(-8deg); }
    80%, 100% { -webkit-transform: scale(1) rotate(0); transform: scale(1) rotate(0); }
  }
</style>



// WEBPACK FOOTER //
// src/components/general/NavFooter.vue